import React from 'react'
import Constants from '../../../app/utils/constants'
import ddxBackground from '../../../assets/images/ddxpage/ddx_bg.webp'
import Header from '../../organisms/Header/Header'

const HeroSection = () => {
  const { ddxHero } = Constants

  return (
    <section className="relative min-h-[550px] w-full overflow-hidden text-white md:min-h-[650px] lg:min-h-[850px]">
      <div className="absolute inset-0">
        <img src={ddxBackground} alt={ddxHero.backgroundAlt} className="h-full w-full object-container" />
      </div>

      <div className="relative z-10">
        <Header />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-[1240px] flex-col px-4 md:px-6 lg:px-8">

        <div className="mx-auto mt-28 flex flex-col items-center text-center md:mt-36 lg:mt-44">
          <h1 className="font-gilroy-bold text-5xl font-semibold uppercase leading-[0.92] md:text-6xl lg:text-8xl xl:text-8xl 2xl:text-8xl">
            {ddxHero.heading}
          </h1>
          <h2 className="mt-5 font-gilroy-medium text-2xl leading-[1.14] md:text-3xl lg:text-4xl xl:text-4xl 2xl:text-5xl">
            {ddxHero.subheading}
          </h2>
          <p className="mt-8 font-gilroy-medium opacity-[80%] text-lg md:text-2xl lg:text-3xl xl:text-4xl  2xl:text-4xl  leading-[1.42] text-white/85 ">
            {ddxHero.description}
          </p>
        </div>
      </div>
    </section>
  )
}

export default HeroSection
